<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/storage-abstract')"></span>
    </div>
    <div class="title">请选择仓储服务 </div>
    <!-- <img class="prepay-img" src='../../assets/img/other/prepaid50.png'> -->
    <br>
    <div class="main">

      <div class="btn-long btn4  no-margin-top" @click="goto('/storage-step2')">
        <div><img src='../../assets/img/storage/c.png'></div>
      </div>
      <div class="btn-long btn1"  @click="goto('/service/form/storage')">
        <div><img src='../../assets/img/storage/a.png'></div>
      </div>
      <div class="btn-long btn5"  @click="goto('/service/form/storage')">
        <div><img src='../../assets/img/storage/b.png'></div>
      </div>
      <div class="btn-long btn2"  @click="goto('/service/form/storage')">
        <div><img src='../../assets/img/storage/d.png'></div>
      </div>
    </div>
    <img :src="pixelURL('cangchu','step1')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'step1',
  data () {
    return {
      order:{
        service:'storage',
        data:{
          username:"",
          userphone:"",
          pick_date:"",
          return_date:"",
          pick_period:"",
          return_period:"",
          baggage: 10,
          student_plan:'',
          pick_street: "",
          pick_suburb: "",
          pick_state: "NSW",
          pick_postcode: "",
          return_street: "",
          return_suburb: "",
          return_state: "NSW",
          return_postcode: "",
          agency: "",
          return_pending:"",
          msg:"",
          coupon_title:"",
          coupon_id:"",
          coupon:"",
          couponLocked:"",
          couponValue:0,
          calc:{},
          calcText:""
        },
      },
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.btn-long{
  width: 85%;
  cursor: pointer;
  color: #fff;
  display: flex;
  align-items: center;
  border-radius: 5px;
  font-size: 0;
  margin: 0 auto;
  margin-top: 26px;
  box-sizing:border-box;
  text-align:left;
  font-weight:bold;
  img{
    width:100%;
  }
}

.btn-intro{
  font-size:0.7em;
  font-weight:normal;
}


.no-margin-top{
  margin-top:0;
}

.btn3{
  background: rgb(255,190,68);
  background:linear-gradient(90deg, #FFBE44 0%,#FBDD88 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(255,190,68,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(255,190,68,0.8);
  box-shadow: 0 10px 16px -10px rgba(255,190,68,0.8);
}

.btn2{
  background: rgb(255,128,154);
  background: linear-gradient(90deg, #FF809A 0%,#FFAC7F 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(255,128,154,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(255,128,154,0.8);
  box-shadow: 0 10px 16px -10px rgba(255,128,154,0.8);
}

.btn1{
  background: rgb(105,205,243);
  background: linear-gradient(90deg, #69CDF3 0%,#87F5E3 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(105,205,243,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(105,205,243,0.8);
  box-shadow: 0 10px 16px -10px rgba(105,205,243,0.8);
}

.btn4{
  background: rgb(105,205,243);
  background:linear-gradient(90deg, #9BB6FF 0%,#ABE0F9 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(155,182,255,0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(155,182,255,0.8);
  box-shadow: 0 10px 16px -10px rgba(155,182,255,0.8);
}

.btn5{
  background: rgb(105,205,243);
  background:linear-gradient(90deg, #F78A3A 0%,#FFC974 100%);
  -webkit-box-shadow: 0 10px 16px -10px rgba(255, 201, 116, 0.8);
  -moz-box-shadow: 0 10px 16px -10px rgba(255, 201, 116, 0.8);
  box-shadow: 0 10px 16px -10px rgba(255, 201, 116, 0.8);
}

.prepay-img{
  width:100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/storage/step1.vue